// extracted by mini-css-extract-plugin
module.exports = {"tablet":"680px","laptop":"980px","desktop":"1180px","column":"column_column__Iesxw","allowOverflow":"column_allowOverflow__tauJM"};